<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <v-footer app>
      <v-layout row>
        <v-container caption>
          <v-row justify="center" class="pt-1 pb-1">
            <strong>{{ clubData.Vereins_Name }}</strong> &nbsp;&nbsp;&nbsp;
            {{ clubData.Vereins_Strasse }}&nbsp;—&nbsp;{{ clubData.Vereins_PlzOrt }}&nbsp;—&nbsp;
            <a :href="'//' + clubData.VER_HOMEPAGE" target="_blank">{{ clubData.VER_HOMEPAGE }}</a>&nbsp;—&nbsp;{{
              clubData.VER_TEL }}
            &nbsp;&nbsp;&nbsp;
          </v-row>
        </v-container>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ clubData: 'GET_CLUB_DATA' })
  }
}
</script>

<style>
html {
  font-family: Arial, sans-serif;
}
</style>
